module.exports = __webpack_public_path__ + "registration-53018bea/Background_01_1x1_a-925ab1c0676a3e6dff3fd9009c367b54.svg";